export default function Grain() {
    return (
        <div
            aria-hidden="true"
            data-testid="film-grain-overlay"
            className="grain"
        />
    );
}
